"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickDismissMigrationNewClub = exports.ClickMigrationNewClub = void 0;
var clickMigrationNewClub_1 = require("./clickMigrationNewClub");
Object.defineProperty(exports, "ClickMigrationNewClub", { enumerable: true, get: function () { return __importDefault(clickMigrationNewClub_1).default; } });
var clickDismissMigrationNewClub_1 = require("./clickDismissMigrationNewClub");
Object.defineProperty(exports, "ClickDismissMigrationNewClub", { enumerable: true, get: function () { return __importDefault(clickDismissMigrationNewClub_1).default; } });
